import React from 'react';
import { Phone, Send, Award, Shield, Zap, CheckCircle2, Users } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';

export const CommercialServices = () => {
  return (
    <section data-testid="commercial-section" className="py-20 bg-[#0D1233]">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <span className="inline-block bg-[#0066FF]/20 text-[#00D9FF] px-5 py-2 rounded-full text-sm font-bold uppercase tracking-wider mb-4">
              Commercial Solutions
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              HVAC Maintenance for Hotels, Estates & Businesses
            </h2>
            <p className="text-base md:text-lg text-gray-400 max-w-3xl mx-auto">
              Reduce downtime, extend equipment life, and ensure comfort with our professional preventative maintenance programs.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <Card className="bg-white/5 backdrop-blur-md border border-white/10 hover:border-[#00D9FF]/30 transition-all duration-300">
              <CardContent className="p-8">
                <div className="flex items-center space-x-3 mb-6">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#0066FF] to-[#00D9FF] rounded-lg flex items-center justify-center">
                    <Award className="w-6 h-6 text-white" />
                  </div>
                  <h3 className="text-2xl font-bold text-white">We Service</h3>
                </div>
                <ul className="space-y-3">
                  {['Hotels & Lodges', 'Residential Estates', 'Office Buildings', 'Restaurants & Cafes', 'Retail Stores', 'Property Management Companies'].map((item, i) => (
                    <li key={i} className="flex items-center space-x-3 text-gray-300">
                      <CheckCircle2 className="w-5 h-5 text-[#00D9FF] flex-shrink-0" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>

            <Card className="bg-gradient-to-br from-[#0066FF] to-[#00D9FF] border-0">
              <CardContent className="p-8">
                <h3 className="text-2xl font-bold text-white mb-6">Maintenance Contract Benefits</h3>
                <ul className="space-y-4">
                  {[
                    { icon: <Shield className="w-5 h-5" />, text: 'Priority Response Times' },
                    { icon: <Zap className="w-5 h-5" />, text: 'Reduced System Breakdowns' },
                    { icon: <CheckCircle2 className="w-5 h-5" />, text: 'Lower Energy Costs' },
                    { icon: <Award className="w-5 h-5" />, text: 'Extended Equipment Lifespan' },
                    { icon: <Phone className="w-5 h-5" />, text: 'Dedicated Account Manager' },
                    { icon: <Users className="w-5 h-5" />, text: 'Flexible Service Scheduling' }
                  ].map((item, i) => (
                    <li key={i} className="flex items-center space-x-3 text-white">
                      <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
                        {item.icon}
                      </div>
                      <span className="font-medium">{item.text}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          </div>

          <div className="text-center">
            <p className="text-gray-400 mb-6 text-base md:text-lg">
              Protect your investment. Prevent costly breakdowns. Ensure guest comfort.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button size="lg" className="bg-white text-[#0A0E27] hover:bg-gray-100 text-lg px-8 py-6 font-bold">
                <a href="tel:0644505026" className="flex items-center space-x-2">
                  <Phone className="w-5 h-5" />
                  <span>Discuss Maintenance Plan</span>
                </a>
              </Button>
              <Button size="lg" className="bg-white/10 border border-white/20 text-white hover:bg-white/20 text-lg px-8 py-6">
                <a href="https://wa.me/27644505026?text=Hi%2C%20I%27m%20interested%20in%20a%20commercial%20HVAC%20maintenance%20contract" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2">
                  <Send className="w-5 h-5" />
                  <span>Request Commercial Quote</span>
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
